unit View.Usuarios.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, System.StrUtils, UHelperServer, UConstantes, XData.Web.Client,
  UUtils, UWeb.Enum, UFramePermissoesUsuario, Vcl.Forms,
  UPersonalizacao_Tabela.Interfaces, UPersonalizacao_Tabela;

type
  TFViewUsuariosList = class(TForm)
    btNew: TButton;
    UsuariosDataset: TXDataWebDataSet;
    UsuariosDatasetid: TIntegerField;
    UsuariosDatasetaliado_id: TIntegerField;
    UsuariosDatasetparceiro_id: TIntegerField;
    UsuariosDatasetperfil: TIntegerField;
    UsuariosDatasetnome: TStringField;
    UsuariosDatasetemail: TStringField;
    UsuariosDatasetstatus: TIntegerField;
    UsuariosDatasetultimo_acesso: TDateTimeField;
    UsuariosDatasetinclusao: TDateTimeField;
    UsuariosDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    UsuariosDatasetperfil_acesso: TStringField;
    tmrConsulta: TTimer;
    XDataClientReenviarLink: TXDataWebClient;
    frmPermissoesUsuario: TFramePermissoesUsuario;
    UsuariosDatasetaliadoNome_Fantasia: TStringField;
    UsuariosDatasetparceironome: TStringField;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure XDataClientReenviarLinkError(Error: TXDataClientError);
    procedure XDataClientReenviarLinkLoad(Response: TXDataClientResponse);
    procedure WebFormShow(Sender: TObject);
    procedure cdsPermissoesServiceAfterOpen(DataSet: TDataSet);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewUsuariosList: TFViewUsuariosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewUsuariosList }

procedure TFViewUsuariosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

procedure TFViewUsuariosList.cdsPermissoesServiceAfterOpen(DataSet: TDataSet);
begin
  TUtils.OcultarDivLoading;
end;

class function TFViewUsuariosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewUsuariosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewUsuariosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewUsuariosList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewUsuariosList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewUsuariosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewUsuariosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewUsuariosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;
  RecordAliadoId,
  RecordAliadoStatus: Integer;
  RecordUsuarioNome : string;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

  procedure PermissoesButtonClick(Sender: TObject);
  begin
    frmPermissoesUsuario.FUsuarioId := RecordAliadoId;
    frmPermissoesUsuario.SetTituloModal('Permissões para o usuário ' + RecordUsuarioNome);
    frmPermissoesUsuario.ReiniciarCds;
    asm
      $('#line-service-tab').tab('show');
    end;
    TUtils.OpenModal('modal_permissoes');
    frmPermissoesUsuario.CarregarCds(frmPermissoesUsuario.cdsPermissoesService);
  end;

  [async]
  procedure ReenviarButtonClick(Sender: TObject); async;
  begin
    if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, 'Tem certeza que deseja reenviar o link de ativação?')) then
    begin
      TUtils.ChamarDivLoading;
      XDataClientReenviarLink.RawInvoke('IService.ReenviarLinkAtivacao', [RecordAliadoId.ToString]);
    end;
  end;

var
  Button: TButton;
  lAumentarColuna : Boolean;
begin
  if ARow = 0 then
    Exit;

  lAumentarColuna := False;

  if WebDBTableControl1.Columns[ACol].Title = 'Ações' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      UsuariosDataset.Connection.Model.DefaultSchema.FindEntityType(UsuariosDataset.EntitySetName),
      UsuariosDataset.CurrentData);
    RecordAliadoId := UsuariosDataset.FieldByName('id').AsInteger;
    RecordAliadoStatus := UsuariosDataset.FieldByName('status').AsInteger;
    RecordUsuarioNome := UsuariosDataset.FieldByName('nome').AsString;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_usuario');
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver dados');

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-user-lock"></i>';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_permissoes_usuario');
    Button.ElementHandle.style.setProperty('padding', '10px');

    if TUtils.PossuiPermissao('permissoes_usuario', TTipoPermissao.VISUALIZAR) then
    begin
      Button.OnClick := @PermissoesButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Ver permissões');
    end
    else
    begin
      Button.ElementClassName := 'btn btn-link text-muted btn-lg';
      Button.ElementHandle.style.setProperty('cursor', 'not-allowed');
    end;


    if TUtils.PossuiPermissao(UsuariosDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) and
      (RecordAliadoStatus = 3) then
    begin
      Button := TButton.Create(nil);
      Button.Caption := '<i class="fas fa-retweet"></i>';
      Button.OnClick := @ReenviarButtonClick;
      Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
      Button.ParentElement := AElement.element;
      Button.WidthStyle := TSizeStyle.ssAuto;
      Button.HeightStyle := TSizeStyle.ssAuto;
      Button.ElementHandle.setAttribute('data-test', 'btn_reenviar_link_ativacao');
      Button.ElementHandle.style.setProperty('padding', '10px');
      Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
      Button.ElementHandle.setAttribute('title', 'Reenviar Link Ativação');

      lAumentarColuna := True;
    end;

    if lAumentarColuna then
      WebDBTableControl1.Columns[ACol].Width := 150;
  end;
end;

procedure TFViewUsuariosList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome', 'email', 'perfil',
      'aliado.Nome_Fantasia']) of
      0, 1, 2, 3 : AClassName := 'text-left';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewUsuariosList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
var
  lAcessosServidores : TArray<string>;
  lIndice : Integer;
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['status', 'perfil', 'perfil_acesso',
      'aliado.Nome_Fantasia']) of
      0:
      begin
        case StrToInt(AValue) of
          1: AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>';
          2: AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo/Bloqueado</div>';
          else  AValue := '<div class="rounded-pill card-warning" style="color: #000;padding-right: 5px;padding-left: 5px;">Aguardando validação</div>';
        end;
      end;
      1:
      begin
        case StrToInt(AValue) of
          1: AValue := 'Facil Sistemas';
          2: AValue := 'Parceiro';
          3: AValue := 'Aliado';
        end;
      end;
      2:
      begin
        if AValue = '99' then
        begin
          AValue := '<i class="fas fa-sync text-primary" style="font-size:20px;padding-right: 7px;padding-left: 7px"><i>' +
            '<i class="fas fa-envelope text-warning" style="font-size:20px;padding-right: 7px;padding-left: 7px"><i>' +
              '<i class="fab fa-whatsapp text-success" style="font-size:20px;padding-right: 7px;padding-left: 7px"><i>';
        end
        else
        begin
          lAcessosServidores := SplitString(AValue, '|');
          AValue := '';

          for lIndice := Low(lAcessosServidores) to High(lAcessosServidores) do
          begin
            case StrToInt(lAcessosServidores[lIndice]) of
              1: AValue := AValue + '<i class="fas fa-sync text-primary" style="font-size:20px;padding-right: 7px;padding-left: 7px"><i>';
              2: AValue := AValue + '<i class="fas fa-envelope text-warning" style="font-size:20px;padding-right: 7px;padding-left: 7px"><i>';
              3: AValue := AValue + '<i class="fab fa-whatsapp text-success" style="font-size:20px;padding-right: 7px;padding-left: 7px"><i>';
            end;
          end;
        end;
      end;
      3:
      begin
        case UsuariosDataset.FieldByName('perfil').AsInteger of
          1: AValue := 'Todos';
          2: AValue := UsuariosDataset.FieldByName('parceiro.Nome').AsString;
        end;
      end;
    end;
  end;
end;

procedure TFViewUsuariosList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('usuarios', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    UsuariosDataset,
    lcPaginator,
    lbPaginationInfo
  );

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'id desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewUsuariosList.WebFormShow(Sender: TObject);
begin
  btNew.Enabled := TUtils.PossuiPermissao(UsuariosDataset.EntitySetName.ToLower, TTipoPermissao.INSERIR);

  if not TUtils.PossuiPermissao('permissoes_usuario', TTipoPermissao.VISUALIZAR) then
    TUtils.RemoverElementoPorId('modal_permissoes');
end;

procedure TFViewUsuariosList.XDataClientReenviarLinkError(
  Error: TXDataClientError);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Error.ErrorMessage);
end;

procedure TFViewUsuariosList.XDataClientReenviarLinkLoad(
  Response: TXDataClientResponse);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Link reenviado com sucesso!');
end;

procedure TFViewUsuariosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.usuarios.list.pagination.info');
  btNew := TButton.Create('view.usuarios.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.usuarios.list.table');
  cbPageSize := TComboBox.Create('view.usuarios.list.cbPageSize');
  edSearch := TEdit.Create('view.usuarios.list.search');
  lcPaginator := TListControl.Create('view.usuarios.list.pagination');
  frmPermissoesUsuario := TFramePermissoesUsuario.Create(Self);
  UsuariosDataset := TXDataWebDataSet.Create(Self);
  UsuariosDatasetid := TIntegerField.Create(Self);
  UsuariosDatasetaliado_id := TIntegerField.Create(Self);
  UsuariosDatasetparceiro_id := TIntegerField.Create(Self);
  UsuariosDatasetperfil := TIntegerField.Create(Self);
  UsuariosDatasetnome := TStringField.Create(Self);
  UsuariosDatasetemail := TStringField.Create(Self);
  UsuariosDatasetstatus := TIntegerField.Create(Self);
  UsuariosDatasetultimo_acesso := TDateTimeField.Create(Self);
  UsuariosDatasetinclusao := TDateTimeField.Create(Self);
  UsuariosDatasetalteracao := TDateTimeField.Create(Self);
  UsuariosDatasetperfil_acesso := TStringField.Create(Self);
  UsuariosDatasetaliadoNome_Fantasia := TStringField.Create(Self);
  UsuariosDatasetparceironome := TStringField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);
  XDataClientReenviarLink := TXDataWebClient.Create(Self);

  frmPermissoesUsuario.LoadFromForm;
  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  frmPermissoesUsuario.BeforeLoadDFMValues;
  frmPermissoesUsuario.lblDescricaoPermissao.BeforeLoadDFMValues;
  UsuariosDataset.BeforeLoadDFMValues;
  UsuariosDatasetid.BeforeLoadDFMValues;
  UsuariosDatasetaliado_id.BeforeLoadDFMValues;
  UsuariosDatasetparceiro_id.BeforeLoadDFMValues;
  UsuariosDatasetperfil.BeforeLoadDFMValues;
  UsuariosDatasetnome.BeforeLoadDFMValues;
  UsuariosDatasetemail.BeforeLoadDFMValues;
  UsuariosDatasetstatus.BeforeLoadDFMValues;
  UsuariosDatasetultimo_acesso.BeforeLoadDFMValues;
  UsuariosDatasetinclusao.BeforeLoadDFMValues;
  UsuariosDatasetalteracao.BeforeLoadDFMValues;
  UsuariosDatasetperfil_acesso.BeforeLoadDFMValues;
  UsuariosDatasetaliadoNome_Fantasia.BeforeLoadDFMValues;
  UsuariosDatasetparceironome.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  XDataClientReenviarLink.BeforeLoadDFMValues;
  try
    Name := 'FViewUsuariosList';
    Width := 777;
    Height := 854;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#245'es';
      Width := 100;
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#211'D.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'email';
      Title := 'email';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'perfil_acesso';
      Title := 'PERFIL ACESSO';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'perfil';
      Title := 'PERFIL';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ultimo_acesso';
      Title := 'ultimo acesso';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'INCLUS'#195'O';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'ALTERA'#199#195'O';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    frmPermissoesUsuario.SetParentComponent(Self);
    frmPermissoesUsuario.Name := 'frmPermissoesUsuario';
    frmPermissoesUsuario.Left := 8;
    frmPermissoesUsuario.Top := 408;
    frmPermissoesUsuario.Width := 768;
    frmPermissoesUsuario.Height := 388;
    frmPermissoesUsuario.TabOrder := 5;
    frmPermissoesUsuario.Visible := False;
    frmPermissoesUsuario.lblDescricaoPermissao.Width := 48;
    frmPermissoesUsuario.lblDescricaoPermissao.Height := 13;
    UsuariosDataset.SetParentComponent(Self);
    UsuariosDataset.Name := 'UsuariosDataset';
    UsuariosDataset.EntitySetName := 'Usuarios';
    UsuariosDataset.Connection := DMConnection.ApiConnection;
    UsuariosDataset.Left := 72;
    UsuariosDataset.Top := 144;
    UsuariosDatasetid.SetParentComponent(UsuariosDataset);
    UsuariosDatasetid.Name := 'UsuariosDatasetid';
    UsuariosDatasetid.FieldName := 'id';
    UsuariosDatasetid.Required := True;
    UsuariosDatasetaliado_id.SetParentComponent(UsuariosDataset);
    UsuariosDatasetaliado_id.Name := 'UsuariosDatasetaliado_id';
    UsuariosDatasetaliado_id.FieldName := 'aliado_id';
    UsuariosDatasetparceiro_id.SetParentComponent(UsuariosDataset);
    UsuariosDatasetparceiro_id.Name := 'UsuariosDatasetparceiro_id';
    UsuariosDatasetparceiro_id.FieldName := 'parceiro_id';
    UsuariosDatasetparceiro_id.Required := True;
    UsuariosDatasetperfil.SetParentComponent(UsuariosDataset);
    UsuariosDatasetperfil.Name := 'UsuariosDatasetperfil';
    UsuariosDatasetperfil.FieldName := 'perfil';
    UsuariosDatasetperfil.Required := True;
    UsuariosDatasetnome.SetParentComponent(UsuariosDataset);
    UsuariosDatasetnome.Name := 'UsuariosDatasetnome';
    UsuariosDatasetnome.FieldName := 'nome';
    UsuariosDatasetnome.Required := True;
    UsuariosDatasetnome.Size := 255;
    UsuariosDatasetemail.SetParentComponent(UsuariosDataset);
    UsuariosDatasetemail.Name := 'UsuariosDatasetemail';
    UsuariosDatasetemail.FieldName := 'email';
    UsuariosDatasetemail.Required := True;
    UsuariosDatasetemail.Size := 255;
    UsuariosDatasetstatus.SetParentComponent(UsuariosDataset);
    UsuariosDatasetstatus.Name := 'UsuariosDatasetstatus';
    UsuariosDatasetstatus.FieldName := 'status';
    UsuariosDatasetstatus.Required := True;
    UsuariosDatasetultimo_acesso.SetParentComponent(UsuariosDataset);
    UsuariosDatasetultimo_acesso.Name := 'UsuariosDatasetultimo_acesso';
    UsuariosDatasetultimo_acesso.FieldName := 'ultimo_acesso';
    UsuariosDatasetultimo_acesso.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    UsuariosDatasetinclusao.SetParentComponent(UsuariosDataset);
    UsuariosDatasetinclusao.Name := 'UsuariosDatasetinclusao';
    UsuariosDatasetinclusao.FieldName := 'inclusao';
    UsuariosDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    UsuariosDatasetalteracao.SetParentComponent(UsuariosDataset);
    UsuariosDatasetalteracao.Name := 'UsuariosDatasetalteracao';
    UsuariosDatasetalteracao.FieldName := 'alteracao';
    UsuariosDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    UsuariosDatasetperfil_acesso.SetParentComponent(UsuariosDataset);
    UsuariosDatasetperfil_acesso.Name := 'UsuariosDatasetperfil_acesso';
    UsuariosDatasetperfil_acesso.FieldName := 'perfil_acesso';
    UsuariosDatasetperfil_acesso.Size := 255;
    UsuariosDatasetaliadoNome_Fantasia.SetParentComponent(UsuariosDataset);
    UsuariosDatasetaliadoNome_Fantasia.Name := 'UsuariosDatasetaliadoNome_Fantasia';
    UsuariosDatasetaliadoNome_Fantasia.FieldName := 'aliado.Nome_Fantasia';
    UsuariosDatasetparceironome.SetParentComponent(UsuariosDataset);
    UsuariosDatasetparceironome.Name := 'UsuariosDatasetparceironome';
    UsuariosDatasetparceironome.FieldName := 'parceiro.nome';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := UsuariosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 360;
    tmrConsulta.Top := 216;
    XDataClientReenviarLink.SetParentComponent(Self);
    XDataClientReenviarLink.Name := 'XDataClientReenviarLink';
    XDataClientReenviarLink.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientReenviarLink, Self, 'OnLoad', 'XDataClientReenviarLinkLoad');
    SetEvent(XDataClientReenviarLink, Self, 'OnError', 'XDataClientReenviarLinkError');
    XDataClientReenviarLink.Left := 592;
    XDataClientReenviarLink.Top := 176;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    frmPermissoesUsuario.AfterLoadDFMValues;
    frmPermissoesUsuario.lblDescricaoPermissao.AfterLoadDFMValues;
    UsuariosDataset.AfterLoadDFMValues;
    UsuariosDatasetid.AfterLoadDFMValues;
    UsuariosDatasetaliado_id.AfterLoadDFMValues;
    UsuariosDatasetparceiro_id.AfterLoadDFMValues;
    UsuariosDatasetperfil.AfterLoadDFMValues;
    UsuariosDatasetnome.AfterLoadDFMValues;
    UsuariosDatasetemail.AfterLoadDFMValues;
    UsuariosDatasetstatus.AfterLoadDFMValues;
    UsuariosDatasetultimo_acesso.AfterLoadDFMValues;
    UsuariosDatasetinclusao.AfterLoadDFMValues;
    UsuariosDatasetalteracao.AfterLoadDFMValues;
    UsuariosDatasetperfil_acesso.AfterLoadDFMValues;
    UsuariosDatasetaliadoNome_Fantasia.AfterLoadDFMValues;
    UsuariosDatasetparceironome.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
    XDataClientReenviarLink.AfterLoadDFMValues;
  end;
end;

end.
